module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABI0lEQVQ4T6WTMU7EMBBFPY5l0UEJPbScAAmBOARtkGNbygEood0qVVDGitiWSyzQ0HMAeqCDiiaxkVESObvxSigurfnvf317gMw8MFNPtgIQcZdzDmmafsWMogBEPCCEPHXCM6XU+xRkEtCLnXNLSilxzqWEkEnIBiAUa60X3tUYcx2DjABT4j52DDIAyrLcZ4w9+9iB86UHSCkfwiSU0tMsyz793QBAxBMAOJZS3nXDV9baWwDwHdxorZf+HhHzJElehRAvI0DYsDHmT8wYO2+aBgBgFULC2Y0SQ7EQ4s0PV1V1FIOMAFPi3q2u68O2bR/XkwwAY8yFtfbex+6d1z9OAEm11qtRB0VR7HHOd/I8/9i2H91r/SilvqMl/mfBZm/jLwNHqxGhungBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./common/assets/img/order/up.png
// module id = NG79
// module chunks = 1